import clienteAxios from "../config/axios";

export async function getAllCuentasCorrientes (companyName) {
    return clienteAxios.get(`/all/cuentasCorrientes/companyName/${companyName}`);
}

export async function getCuentasCorrientesByNroCta (nroCta, companyName) {
    return clienteAxios.get(`/cuentasCorrientes/nroCta/${nroCta}/companyName/${companyName}`);
}

export async function deleteAndGetCuentasCorrientesByNroCtaFromSoftland (nroCta, companyName) {
    return clienteAxios.get(`/deleteAndGet/cuentasCorrientesByNroCtaFromSoftland/nroCta/${nroCta}/companyName/${companyName}`);
}
